(() => {
  if (window.DecoCollectionFiltersInitialized) return;
  window.DecoCollectionFiltersInitialized = true;

  let shouldRestoreDrawer = false;
  let openGroupLabel = '';
  let drawerScrollTop = 0;
  let lastTrigger = null;

  const isDrawerVisible = (drawer) => drawer && window.getComputedStyle(drawer).display !== 'none';

  const setTriggerState = (section, expanded) => {
    const trigger = section?.querySelector('.m-sidebar--open');
    if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  };

  const openFilterDrawer = (control, requestedGroup = '') => {
    const section = control.closest('.facest-filters-section');
    const trigger = section?.querySelector('.m-sidebar--open');
    const drawer = section?.querySelector('.m-sidebar');
    if (!trigger || !drawer) return;

    trigger.click();
    shouldRestoreDrawer = true;
    lastTrigger = control;
    setTriggerState(section, true);

    window.requestAnimationFrame(() => {
      if (requestedGroup) {
        const group = [...drawer.querySelectorAll('[data-filter-label]')].find(
          (widget) => widget.dataset.filterLabel === requestedGroup
        );
        if (group) {
          if (!group.classList.contains('open')) {
            group.querySelector('.m-accordion--item-button')?.click();
          }
          group.scrollIntoView({ block: 'start', behavior: 'smooth' });
          group.querySelector('input:not([disabled])')?.focus({ preventScroll: true });
        }
      } else {
        const content = drawer.querySelector('.m-sidebar--content');
        if (content) content.scrollTop = 0;
        drawer.querySelector('.m-sidebar--close')?.focus({ preventScroll: true });
      }
    });
  };

  document.addEventListener('click', (event) => {
    const shortcut = event.target.closest('[data-deco-filter-group]');
    if (shortcut) {
      openFilterDrawer(shortcut, shortcut.dataset.decoFilterGroup);
      return;
    }

    const allFilters = event.target.closest('[data-deco-filter-all]');
    if (allFilters) {
      openFilterDrawer(allFilters);
      return;
    }

    const trigger = event.target.closest('.m-sidebar--open');
    if (trigger) {
      shouldRestoreDrawer = true;
      lastTrigger = trigger;
      setTriggerState(trigger.closest('.facest-filters-section'), true);
      window.requestAnimationFrame(() => {
        trigger.closest('.facest-filters-section')?.querySelector('.m-sidebar--close')?.focus({ preventScroll: true });
      });
      return;
    }

    const close = event.target.closest('.m-sidebar--close');
    const backdrop = event.target.matches('.m-sidebar') ? event.target : null;
    if (close || backdrop) {
      const section = (close || backdrop).closest('.facest-filters-section');
      shouldRestoreDrawer = false;
      openGroupLabel = '';
      drawerScrollTop = 0;
      setTriggerState(section, false);
      window.requestAnimationFrame(() => lastTrigger?.focus({ preventScroll: true }));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const drawer = document.querySelector('.m-sidebar--fixed .m-sidebar');
    if (!isDrawerVisible(drawer)) return;
    drawer.querySelector('.m-sidebar--close')?.click();
  });

  document.addEventListener('input', (event) => {
    const form = event.target.closest('.m-sidebar--fixed collection-filters-form');
    if (!form) return;

    const drawer = form.closest('.m-sidebar');
    const openGroup = form.querySelector('.m-filter--widget.open .m-filter--widget-title');
    shouldRestoreDrawer = true;
    openGroupLabel = openGroup?.textContent.trim().replace(/\s+/g, ' ') || '';
    drawerScrollTop = drawer?.querySelector('.m-sidebar--content')?.scrollTop || 0;
  });

  const observer = new MutationObserver(() => {
    if (!shouldRestoreDrawer) return;

    const section = document.querySelector('.facest-filters-section[data-filters-position="fixed"]');
    const drawer = section?.querySelector('.m-sidebar');
    const trigger = section?.querySelector('.m-sidebar--open');
    if (!drawer || !trigger || isDrawerVisible(drawer)) return;

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        if (!shouldRestoreDrawer || isDrawerVisible(drawer)) return;
        trigger.click();

        window.requestAnimationFrame(() => {
          if (openGroupLabel) {
            const widgets = [...drawer.querySelectorAll('.m-filter--widget')];
            const matchingWidget = widgets.find((widget) => {
              const title = widget.querySelector('.m-filter--widget-title');
              return title?.textContent.trim().replace(/\s+/g, ' ') === openGroupLabel;
            });
            if (matchingWidget && !matchingWidget.classList.contains('open')) {
              matchingWidget.querySelector('.m-accordion--item-button')?.click();
            }
          }

          const content = drawer.querySelector('.m-sidebar--content');
          if (content) content.scrollTop = drawerScrollTop;
        });
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
